/**
 * APIレスポンスのステータス
 */
export enum Status {
  /**
   * 正常
   */
  Success = 'success',
  /**
   * タイムアウト
   */
  Timeout = 'timeout',
  /**
   * 内部エラー
   */
  InternalError = 'internalError',
  /**
   * バリデーションエラー
   */
  ValidateError = 'validateError',
  /**
   * 該当ユーザー無し
   */
  NotFoundConnector = 'notFoundConnector',
  /**
   * 範囲外エラー
   */
  OutOfRange = 'outOfRange',
  /**
   * 紹介ポジション該当なし
   */
  NotFoundInvitePosition = 'notFoundInvitePosition',
  /**
   * 法人証明書が見つからない
   */
  NotFoundCompanyLicense = 'notFoundCompanyLicense',
  /**
   * 登録済み
   */
  AlreadyRegistered = 'alreadyRegistered',
  /**
   * ポジション未契約
   */
  NotFoundPosition = 'notFoundPosition',
  /**
   * ATEMクエストID重複
   */
  DuplicateAtemQuestId = 'duplicateAtemQuestId',
  /**
   * 契約不可能ポジションナンバー
   */
  InvalidPositionNumber = 'invalidPositionNumber',
  /**
   * 契約済み
   */
  AlreadyContracted = 'alreadyContracted',
  /**
   * 名義変更不可
   */
  CantPositionAssignment = 'cantPositionAssignment',

  /**
   * パナシアペイ口座作成失敗
   */
  PanaceaPayFailure = 'panaceaPayFailure',
  /**
   * TRUSTDOCK API失敗
   */
  TrustDockFailure = 'trustDockFailure',

  /**
   * バイナリマップが存在しない
   */
  NotFoundBinaryMap = 'notFoundBinaryMap',

  /**
   * 報酬明細が見つからない
   */
  NotFoundReward = 'notFoundReward',
  /**
   * 報酬明細が非公開
   */
  PrivateReward = 'privateReward',

  /**
   * キャンペーン QR トークン復号失敗・キャンペーン用でない (要件書 §4.1 / §4.14)
   */
  CampaignQrInvalid = 'campaignQrInvalid',
  /**
   * キャンペーン QR トークン期限切れ (発行から1年経過、Rev.12 S16 / §4.14)
   */
  CampaignQrExpired = 'campaignQrExpired',
  /**
   * 同メアドの有効期限内キャンペーン申込トークンが既存 (要件書 §4.5 ステージA / Rev.15 S38)
   */
  CampaignAlreadyApplied = 'campaignAlreadyApplied',
  /**
   * キャンペーン確認メールトークンが無効・期限切れ・使用済 (要件書 §4.5 ステージB)
   */
  CampaignTokenInvalid = 'campaignTokenInvalid',
  /**
   * キャンペーン失効後ログイン (要件書 §4.7 / Rev.16 D1)
   */
  CampaignUserInvalidated = 'campaignUserInvalidated',
  /**
   * Quest 認証 API でメアド不存在 / パスワード不一致 (要件書 §3.2.1 / Rev.17 S40 / ELL_Portal API §3.3 INVALID_CREDENTIALS)
   * 情報漏洩抑制のため両ケースで同 status を返す (BE PR #335 Phase 2-2 で追加)
   */
  QuestAuthFailed = 'questAuthFailed',
  /**
   * Quest 認証 API で対象ユーザーの account_status != 1 (要件書 §3.2.1 / Rev.17 S40 / ELL_Portal API §3.3 ACCOUNT_DISABLED)
   */
  QuestAccountDisabled = 'questAccountDisabled',
}
